import TableCell from './TableCell';

export * from './TableCellProps';
export default TableCell;
